import api from "@/router/api"

export default {
    getAllOcaTypes({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesOcaTypes.list(payload)
                .then(response => {
                    resolve(response.data.data)
                    commit('SET_OCATYPES', response.data.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener las empresas',
                    })
                })
        })
    },
    searchOcaTypes({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesOcaTypes.search(payload)
                .then(response => {
                    resolve(response.data.data)
                    commit('SET_OCATYPES', response.data.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener las empresas',
                    })
                })
        })
    },
    findOcaType({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesOcaTypes.find(payload)
                .then(response => {
                    resolve(response.data.data)
                    commit('SET_OCATYPE', response.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener la empresa',
                    })
                })
        })
    },

    createOcaType({commit}, payload){
        commit('CLEAR_VALIDATION')
        return new Promise((resolve, reject) => {
            api.auxiliariesOcaTypes.create(payload)
                .then(response => {
                    const {data} = response.data
                    commit('SET_OCATYPE', response.data.data)
                    resolve(data)
                })
                .catch(error => {
                    const { data, status} = error.response
                    const { message: title } = data

                    if(status === 422){
                        commit('SET_VALIDATION_ERRORS', data.errors)
                    }
                    reject({title, status})
                })
        })
    },
    updateOcaType({commit}, payload){
        commit('CLEAR_VALIDATION')
        return new Promise((resolve, reject) => {
            api.auxiliariesOcaTypes.update(payload)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(error => {
                    const { data, status} = error.response
                    const { message: title } = data

                    if(status === 422){
                        commit('SET_VALIDATION_ERRORS', data.errors)
                    }
                    reject({title, status})
                })
        })
    },
    deleteOcaType({commit}, payload) {
        return new Promise((resolve, reject) => {
            api.auxiliariesOcaTypes.delete(payload.id)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(() => {
                    reject({
                        message: 'Error al eliminar la empresa',
                    })
                })
        })
    },
}